import { DynamicInputControl } from '.';
import { SessionStore } from '../services/SessionStore';
import { EVariableType, ESessionStore } from '../data/Constants';
import type { IVariableInputProps } from '../../types';

/**
 * Renders the container for the dynamic input control with additional icons for locked state and short sales text.
 * @param {IVariableInputProps} props the properties for the variable input component
 * @returns {JSX.Element} the container for the dynamic input control
 */
export const VariableInput = ({
  variable,
  type,
  onChange,
  onOptionalChange,
}: IVariableInputProps) => {
  const isGuarded = variable.isGuarded;
  const isGuardedTab = SessionStore.get(ESessionStore.IsGuardedTab);
  const variableType = type === '' ? variable.variableType : type;
  //if property is guarded show it only in guarded tab except for submodel
  //if property is non guarded and any type show it in respective tab
  return isGuarded && variableType !== EVariableType.Submodel && !isGuardedTab ? null : (
    <DynamicInputControl
      variable={variable}
      onChange={onChange}
      onOptionalChange={onOptionalChange}
      type={variableType}
    />
  );
};
